// extracted by mini-css-extract-plugin
module.exports = {"SimplePagination":"SimplePagination_SimplePagination__2Azqe"};